export default __webpack_public_path__ + "static/media/atelier-default-bg.afa44894.png";